import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  display: "flex",
  alignItems: "center",
  borderRadius: 9999,
  height: "100%",
  width: "100%",
  overflow: "hidden", // needed for borderRadius to show
};

export const genSegment = (
  color: string,
  percentWidth: number,
  isInset?: boolean,
): CSSProperties => ({
  flexGrow: 1,
  backgroundColor: color,
  width: `${percentWidth * 100}%`,
  transition: "width .4s",
  height: "100%",
  boxShadow: isInset ? `inset 0 1px 1px ${greys.cloudyBlue}` : "",
});
